import { render, staticRenderFns } from "./FriendlyLink.vue?vue&type=template&id=bef15c52&scoped=true"
import script from "./FriendlyLink.vue?vue&type=script&lang=js"
export * from "./FriendlyLink.vue?vue&type=script&lang=js"
import style0 from "./FriendlyLink.vue?vue&type=style&index=0&id=bef15c52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef15c52",
  null
  
)

export default component.exports